/**
 * Influencer Form Validation
 * Requires at least one social media handle to be filled
 */
export class InfluencerForm {
    constructor() {
        this.formHandle = 'influencerForm';
        this.socialFields = [
            'instagramhandle',
            'facebookhandle',
            'tiktokhandle',
            'youtubehandle'
        ];
        this.errorMessage = 'Please provide at least one social media handle.';
    }

    init() {
        // Find forms with the influencerForm handle
        const form = document.querySelector(`input[name="handle"][value="${this.formHandle}"]`)?.closest('form');

        if (!form) return;

        this.form = form;
        this.setupValidation();
    }

    setupValidation() {
        // Listen for Formie's validation event
        this.form.addEventListener('onFormieValidate', (e) => {
            if (!this.validateSocialFields()) {
                e.preventDefault();
                this.showError();
            } else {
                this.hideError();
            }
        });

        // Also handle standard submit as fallback
        this.form.addEventListener('submit', (e) => {
            if (!this.validateSocialFields()) {
                e.preventDefault();
                this.showError();
            }
        });

        // Clear error when user starts typing in any social field
        this.socialFields.forEach(fieldClass => {
            const field = this.form.querySelector(`.${fieldClass} input`);
            if (field) {
                field.addEventListener('input', () => this.hideError());
            }
        });
    }

    validateSocialFields() {
        return this.socialFields.some(fieldClass => {
            const input = this.form.querySelector(`.${fieldClass} input`);
            return input && input.value.trim() !== '';
        });
    }

    showError() {
        // Check if error already exists
        if (this.form.querySelector('.social-fields-error')) return;

        // Find the first social field to insert error before it
        const firstSocialField = this.form.querySelector(`.${this.socialFields[0]}`);
        if (!firstSocialField) return;

        const errorDiv = document.createElement('div');
        errorDiv.className = 'fui-alert fui-alert-error social-fields-error';
        errorDiv.textContent = this.errorMessage;

        firstSocialField.parentNode.insertBefore(errorDiv, firstSocialField);

        // Scroll error into view
        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    hideError() {
        const error = this.form?.querySelector('.social-fields-error');
        if (error) {
            error.remove();
        }
    }
}
